import React from 'react'
import SbEditable from 'storyblok-react'

export type TextareaBlok = StoryblokComponent & {
  id: string
  name: string
  label: string
  placeholder?: string
  marginTop?: number
  marginBottom?: number
}

export interface TextareaProps {
  blok: TextareaBlok
}

export const Textarea = ({ blok }: TextareaProps) => {
  const marginTopClass = blok.marginTop ? `${blok.marginTop}px` : ''
  const marginBottomClass = blok.marginBottom ? `${blok.marginBottom}px` : ''

  return (
    <div
      style={{
        marginTop: marginTopClass,
        marginBottom: marginBottomClass,
      }}
    >
      {/** @ts-ignore: Storyblok typing issue with children **/}
      <SbEditable content={blok} key={blok._uid}>
        <div className="flex flex-col gap-2">
          <label className="text-sm font-medium text-gray-700">{blok.label}</label>
          <textarea
            id={blok.id}
            name={blok.name}
            className="min-h-[100px] w-full rounded-md border border-gray-300 bg-white px-3 py-2 text-sm placeholder:text-gray-400 focus:outline-none focus:ring-2 focus:ring-gray-400 focus:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50"
            placeholder={blok.placeholder}
          />
        </div>
      </SbEditable>
    </div>
  )
}

Textarea.displayName = 'Textarea Block'